<div class="map-container">
  <!-- Loading Overlay -->
  @if (isLoadingComponents) {
  <div class="loading-overlay">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <p>Loading components...</p>
    </div>
  </div>
  }

  <!-- Drawing Controls -->
  <div class="drawing-controls">
    <button
      mat-raised-button
      [color]="isDrawingMode ? 'warn' : 'primary'"
      (click)="toggleDrawMode()"
      class="draw-button"
    >
      <mat-icon>{{ isDrawingMode ? "close" : "draw" }}</mat-icon>
      {{ isDrawingMode ? "Cancel" : "Draw" }}
    </button>

    @if (isDrawingMode) {
    <button mat-raised-button color="primary" (click)="finishShape()" class="finish-button">
      <mat-icon>check</mat-icon>
      Finish shape
    </button>
    }

    <button
      mat-raised-button
      color="primary"
      (click)="saveGeofence()"
      class="save-button"
      [disabled]="!hasUnsavedPolygon"
    >
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button mat-raised-button color="accent" (click)="clearPolygons()" class="clear-button">
      <mat-icon>delete</mat-icon>
      Clear
    </button>
  </div>

  <div id="map"></div>
</div>
